import Api from 'libs/api';
import AuthService from 'services/Auth';

class ReservationsApi extends Api {
  constructor(restaurantID) {
    const resId = restaurantID || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/reservations`);
  }

  updateStatus = (id, params) => {
    return this.buildQuery('post', params, `${id}/update_status`);
  }
}

export default ReservationsApi;
